module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-button-dropdown",
    attrs: {
      "data-uk-dropdown": "{mode:'click'}"
    }
  }, [_vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "uk-dropdown"
  }, [_c('ul', {
    staticClass: "uk-nav uk-nav-dropdown"
  }, _vm._l((_vm.items), function(item) {
    return _c('li', {
      class: {
        'uk-nav-header': item.isHeader
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.selectItem(item)
        }
      }
    }, [_vm._v(_vm._s(item[_vm.textField]))])])
  }))])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5df85ca9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UkDropdown.vue
// module id = 295
// module chunks = 2